import {connect} from "react-redux";
import {manualCalculationsCheckForChangesApplied} from "../helpers/sqftCalculations";
import {ConfirmPopupTypes} from "../../visComponents/constants";
import {setCameFromPage, toggleConfirmPopup, toggleSelectionFeatureInfo} from "../../../actions/actionFunctions";
import {setSqftFromFeature} from "../../../actions/sqftFunctions";
import {withRouter} from "react-router-dom";

import workspaceHistory from "../components/canvas/core/workspaceHistory";
import {useCloseSQFTCalc} from "./useCloseSQFTCalc";
import {enableRegularMode} from "../components/canvas/store/canvasHelper";
import {clearAllMenusEvents} from "../components/canvas/core/workspace/workspaceEvents";
import {showSlabTool} from "../../../actions/sqftSlabFunctions";

const WithSqftFooterCancel = (props) => {
  const {showManualCalculation, toggleConfirmPopup, showSlabTool} = props;
  const {children} = props;
  const {closeSQFTCalc} = useCloseSQFTCalc();

  const handleCancelClick = () => {
    if (showManualCalculation) {
      manualCalculationsCheckForChangesApplied() ? callResetDataPopup() : closeSQFTCalc(false);
    } else {
      showSlabTool(false);
      enableRegularMode();
      clearAllMenusEvents();
      workspaceHistory.checkForChangesApplied() ? callResetDataPopup() : closeSQFTCalc(false);
    }
  };

  const callResetDataPopup = () => {
    toggleConfirmPopup(true, ConfirmPopupTypes.SqftResetChanges);
  };

  return children(handleCancelClick);
};

const mapStateToProps = (store) => ({
  cameFromPage: store.cartState.cameFromPage,
  showManualCalculation: store.sqftManualCalculationState.showManualCalculation,
  activePreset: store.bathroomVisualizerState.activePreset,
  bvPresets: store.bathroomVisualizerState.bvPresets,
});

const mapDispatchToProps = {
  toggleConfirmPopup,
  toggleSelectionFeatureInfo,
  setCameFromPage,
  setSqftFromFeature,
  showSlabTool,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WithSqftFooterCancel)
);
